export const export_mixin = {
    data() {
        return {}
    },
    methods: {
        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        },

        async finalDownload2(workbook, fileName) {
            console.log("finalDownload2")
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);

            link.download = `${fileName}.xlsx`
            link.click();

            URL.revokeObjectURL(link.href);
        },


        getHeader(formNameList) {
            let header = []
            formNameList.forEach(item => {
                header.push(item.title)
            })
            return header
        },
        getRowData(formNameList, item) {
            let rowData = []
            formNameList.forEach(formItem => {
                rowData.push(formItem.valueGetter(item))
            })
            return rowData
        },

    }
}
